import { render, staticRenderFns } from "./ComputadorDialog.vue?vue&type=template&id=53db65e3"
import script from "./ComputadorDialog.vue?vue&type=script&lang=js"
export * from "./ComputadorDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports